<script lang="ts" setup>
import FooterBrand from './FooterBrand.vue'
import FooterLegal from './FooterLegal.vue'
import FooterContact from './FooterContact.vue'
import FooterDownload from './FooterDownload.vue'
</script>

<template>
  <footer style="background: #1a1a2e">
    <!-- 上部分：191px，4 等分列，内容居左 -->
    <div style="width: 1200px; margin: 0 auto; height: 191px; display: grid; grid-template-columns: repeat(4, 1fr); align-items: flex-start; padding-top: 40px; box-sizing: border-box">
      <FooterBrand />
      <FooterLegal />
      <FooterContact />
      <FooterDownload />
    </div>

    <!-- 分割线 -->
    <div style="width: 1200px; margin: 0 auto">
      <div style="height: 1px; background: #FFFFFF; opacity: 0.2" />
    </div>

    <!-- 下部分：60px -->
    <div style="width: 1200px; margin: 0 auto; height: 60px; display: flex; align-items: center; justify-content: center">
      <p style="font-size: 16px; color: #FFFFFF">
        All rights reserved. 2024 Beijing Chinese All Culture Media Co., Ltd.©
      </p>
    </div>
  </footer>
</template>
